import { LatLngLiteral } from '@googlemaps/google-maps-services-js';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserServiceCreateResponseJson } from '@vmspdb/definitions';
import { ApiPaginated } from '@vmspdb/ui/domain';

export const PaginatedUserActions = createActionGroup({
  source: 'PaginatedUser',
  events: {
    Nothing: emptyProps(),
    Cancel: emptyProps(),
    'List PaginatedUsers': props<{
      params: Record<string, unknown>;
    }>(),
    'List PaginatedUsers Success': props<{
      data: ApiPaginated<UserServiceCreateResponseJson>;
    }>(),
    'List PaginatedUsers Failure': props<{ error: unknown }>(),
    'Set Ref Geopoint': props<{ refGeoPoint?: LatLngLiteral }>(),
  },
});
